// src/components/ChairmanSection.jsx
import React from 'react';
import '../styles/ChairmanSection.css';
import chairmanImg from '../Assets/Images/jamil-sir.jpg'; // replace with correct path

function ChairmanSection() {
  return (
    <div className="chairman-section" id="md">
      
      <div className="chairman-image-wrapper">
        <div className="image-circle">
          <img src={chairmanImg} alt="Managing Director Sk Jamil Uddin" className="chairman-img" />
        </div>
        <div className="chairman-name">
          <p><strong>Sk Jamil Uddin</strong><br />Managing Director - Akij Insaf Ltd.</p>
        </div>
      </div>
      <div className="chairman-text">
        <p className="intro">Sk Jamil Uddin</p>
        <h1 className="title">Our Revered Managing Director</h1>
        <p className="statement">
          To establish ourselves as the most trusted and globally accepted conglomerates by maintaining
          the quality products ever. We hand over the products to consumers that we use ourselves.
        </p>
        <p className="statement">
          To contribute to the overall economy of the country by creating better opportunities and
          employment for the next generation, In-Sha-Allah.
        </p>
      </div>
    </div>
  );
}

export default ChairmanSection;
